








































































































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { CardType } from "@/shared/models/cardType";
import { PaymentMean } from "@/shared/models/paymentMean";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import { FinDocViewModel } from "./FinancialDocumentFormParts/models";
import { PaymentMeansEnum } from "@/shared/models/enums.type";
import { getPriceSummary } from "./FinancialDocumentFormParts/functions";
import { PaymentModel } from "./FinancialDocumentFormParts/models";
import LoadingOverlay from "../misc/LoadingOverlay.vue";
import DateTimeOffsetField from "@/components/misc/DateTimeOffsetField.vue";
import { round } from "@/components/numbers/numberFormatUtils";
import * as _ from "lodash";

@Component({
  components: {
    DateField,
    TimeField,
    LoadingOverlay,
    NumericInputImproved,
    DateTimeOffsetField,
  },
})
export default class FinancialDocumentPaymentsModal extends Vue {
  @PropSync("open") isOpen?: boolean;
  @PropSync("internalLoading") loading?: boolean;
  @PropSync("payments") internalPayments?: PaymentModel[];
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;

  @Prop() workingCurrencyId?: number;
  @Prop() formalCurrencyId?: number;
  @Prop() workingCurrencyISO3?: string;
  @Prop() formalCurrencyISO3?: string;
  @Prop() paymentMeansId?: number;
  @Prop({ default: 0 }) amountDue?: number;
  @Prop() automaticallyCancelRelatedAdvanceInvoices?: boolean;

  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Action("codebooks/refreshCardTypes") refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  @Getter("appParams/isCardTypeRequiredForCardPaymentMeans")
  isCardTypeRequiredForCardPaymentMeans?: boolean;

  paymentMeansEnum = PaymentMeansEnum;
  isFormValid = false;
  fkey = 0;

  @Watch("isOpen")
  isOpenWatch(fresh: boolean) {
    if (fresh) {
      if (
        this.internalPayments != undefined &&
        this.internalPayments.length == 0
      ) {
        this.addPayment(this.invoiceUnpaidTotalRounded);
      }
    }
  }

  getAvailableCardTypes(detail: { cardTypeId?: number }): CardType[] {
    if (!this.cardTypes) return [];

    return this.cardTypes.filter(c => {
      if (detail.cardTypeId === c.id) return true;
      return !c.name.includes('- VCC');
    });
  }
  
  addPayment(amount?: number) {
    const today = new Date();
    this.internalPayments?.push({
      id: 0,
      amount: amount ?? 0,
      paymentDate: today.toISOString(),
      remainingAmount: amount ?? 0,
      amountToAsign: amount ?? 0,
      currencyId: this.formalCurrencyId ?? null,
      currencyCode: this.formalCurrencyISO3 ?? "",
      paymentMeansId:
        this.paymentMeansId !== this.paymentMeansEnum.Ostalo
          ? this.paymentMeansId ?? null
          : null,
      cardTypeId: null,
      alreadyPaidForFinDoc: null,
    });
  }

  shouldShowCardType(paymentMeansId: number) {
    return (
      paymentMeansId === this.paymentMeansEnum.KreditnaKartica ||
      paymentMeansId === this.paymentMeansEnum.BankovnaKartica ||
      this.getPaymentMeanBaseId(paymentMeansId) ===
        this.paymentMeansEnum.KreditnaKartica ||
      this.getPaymentMeanBaseId(paymentMeansId) ===
        this.paymentMeansEnum.BankovnaKartica
    );
  }

  paymentColsSize(paymentMeansId: number) {
    return this.shouldShowCardType(paymentMeansId) ? 2 : 3;
  }

  cardColsSize(paymentMeansId: number) {
    return this.shouldShowCardType(paymentMeansId) ? 2 : 1;
  }

  get totalToPay() {
    const summary = getPriceSummary(this.finDocModelInternal);
    return this.automaticallyCancelRelatedAdvanceInvoices
      ? summary.toPayWithoutAdvance
      : summary.toPay;
  }

  get amountDueRounded() {
    const rounded = _.round(this.totalToPay ?? 0, 2);

    // because JS has signed zeros
    return rounded === 0 ? 0 : rounded;
  }

  get invoiceUnpaidTotal() {
    return this.amountDueRounded ?? 0;
  }

  get invoiceUnpaidTotalRounded() {
    const rounded = _.round(this.invoiceUnpaidTotal, 2);

    // because JS has signed zeros
    return rounded === 0 ? 0 : rounded;
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      mustBeZero: (value: any) =>
        value === 0 || this.$t("Validation.MustBeZero"),
      cannotBeMoreThanRemaining: (amount: number, remainingAmount: number) =>
        amount <= remainingAmount ||
        this.$t("Validation.CannoBeMoreThanRemaining"),
      mustBeEqualToTotal: () =>
        this.totalToPay === this.totalAssigned ||
        this.$t("Validation.MustBeEqualToTotal"),
    };
  }

  get allowedCurrencies() {
    return [
      {
        id: this.formalCurrencyId,
        isoCode: this.formalCurrencyISO3,
      },
      ...(this.formalCurrencyId !== this.workingCurrencyId
        ? [
            {
              id: this.workingCurrencyISO3,
              isoCode: this.workingCurrencyISO3,
            },
          ]
        : []),
    ];
  }

  getAmountLeftToAsign(payment: PaymentModel) {
    return (payment.remainingAmount ?? 0) - (payment.amountToAsign ?? 0);
  }

  save() {
    if (this.amountsAreValid) {
      this.$emit("saveLockAndMarkAsPaid");
    }
  }

  get amountsAreValid() {
    let sum = this.internalPayments?.reduce(
      (sum, x) => sum + (x.amountToAsign ?? 0),
      0
    );

    if (sum !== undefined) sum = round(sum);

    return sum === this.invoiceUnpaidTotalRounded;
  }

  //amount can change only when adding new payments - field is disabled otherwise
  amountChanged(payment: PaymentModel) {
    payment.remainingAmount = payment.amount;
    if (payment.id == 0) {
      payment.amountToAsign = payment.amount;
    }
  }

  get existingPaymentsExist() {
    return this.internalPayments?.some((x) => !!x.id);
  }

  get newPaymentsExist() {
    return this.internalPayments?.some((x) => x.id === 0);
  }

  getPaymentMeanBaseId(id: number) {
    return this.paymentMeans?.find((e) => e.id === id)?.paymentMeanBaseId;
  }

  get existingPayments() {
    return this.internalPayments?.filter((x) => !!x.id);
  }

  get newPayments() {
    return this.internalPayments?.filter((x) => x.id === 0);
  }

  get totalAssigned() {
    return (
      this.internalPayments?.reduce(
        (sum, x) => sum + (x.amountToAsign ?? 0),
        0
      ) || 0
    );
  }

  get showBottomInfoBox() {
    return !this.amountsAreValid;
  }

  get amountLeftToAssign() {
    const total = round(
      this.internalPayments?.reduce(
        (sum, x) => sum + (x.amountToAsign ?? 0),
        0
      ) ?? 0
    );
    const amountLeft = this.invoiceUnpaidTotalRounded - total;

    // because JS has signed zeros
    return amountLeft === 0 ? 0 : amountLeft;
  }

  get totalAssignedAmount() {
    return this.internalPayments?.reduce(
      (sum, x) => sum + (x.amountToAsign ?? 0),
      0
    );
  }
}
